/**
 * Plugins pour gérer les icons des pays -> flag
 */
import Vue from 'vue';
import FlagIcon from 'vue-flag-icon-2';


Plugin.install = function (inoVue, options) { // eslint-disable-line
};

Vue.use(FlagIcon);

export default Plugin;
